// Coordinates are relative to the supplied container, or document coordinates
// for the existing Fretboard Trainer caller. Return cleanup for mounted owners.
function highlightClick(x, y, { container = document.body, color = "red",
  duration = 500, size = 20, result = "click" } = {}) {
  const circle = document.createElement("div");
  circle.setAttribute("aria-hidden", "true");
  circle.dataset.noteFeedback = result;
  Object.assign(circle.style, {
    position: "absolute", left: `${x - size / 2}px`, top: `${y - size / 2}px`,
    width: `${size}px`, height: `${size}px`, borderRadius: "50%",
    pointerEvents: "none", zIndex: "1",
    background: `radial-gradient(circle at center, ${color} 0%, transparent 70%)`,
  });
  container.appendChild(circle);
  const timeout = setTimeout(() => circle.remove(), duration);
  return () => { clearTimeout(timeout); circle.remove(); };
}

export default highlightClick;
